<template>
  <v-dialog v-model="value" width="1200" height="500">
    <v-card>
      <v-card-title>
        <span class="headline font-weight-thin">Tag Change History</span>
      </v-card-title>
      <v-card-text class="mt-3">
        Below you will see the history of changes for <b>{{ tag.label }}.</b>
      </v-card-text>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="tagHistory"
          :items-per-page="5"
          class="elevation-0"
          data-cy="tagHistory"
          data-test="tagHistory"
          dense
          item-key="logId"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td data-cy="operation">{{ item.operation === "create" ? "Created" : "Updated" }}</td>
              <td data-cy="created">{{ formatUTCtoPST(item.created) }}</td>
              <td data-cy="username">{{ formatUsername(item.username) }}</td>
              <td data-cy="changeHistory" class="py-2">
                <template v-if="item.operation === 'create'">
                  <div v-for="(value, key) in item.content" :key="key">
                    <div v-if="key !== 'serviceAreaId'">
                      <b>{{ key }}:</b> {{ value }}
                    </div>
                  </div>
                </template>
                <template v-if="item.operation === 'update'">
                  <div v-for="(value, key) in item.content" :key="value.key">
                    <div>
                      <b>{{ value.key }}:</b>
                    </div>

                    <div class="pl-2">
                      <b>old value:</b>
                      <span v-if="value.oldValue"> {{ value.oldValue }}</span>
                      <span class="empty-value" v-else> null</span>
                    </div>

                    <div class="pl-2">
                      <b>new value:</b>
                      <span v-if="value.newValue"> {{ value.newValue }}</span>
                      <span class="empty-value" v-else> null</span>
                    </div>

                    <v-divider
                      v-if="item.content.length > 1 && key !== item.content.length - 1"
                      class="my-2"
                    ></v-divider>
                  </div>
                </template>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn @click="close" class="mr-2" outlined data-cy="closeAuditHistory">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatUsername, formatUTCtoPST } from "@/lib/formatters";
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  computed: {
    ...mapGetters({
      userMap: "user/getUserMap",
    }),
    ...mapState({
      tag: state => state.admin.tag.record,
      tagHistory: state => state.auditLog.tag,
      serviceAreaId: state => state.session.serviceArea,
      userList: state => state.user.userList,
    }),
  },
  async created() {
    try {
      await Promise.all([this.fetchUserList()]);
    } catch (e) {
      console.log(e);
      this.$notifyError("Error fetching user list");
    }
  },
  data() {
    return {
      valid: false,
      headers: [
        { text: "Operation", vale: "operation" },
        { text: "Date Updated", value: "created" },
        { text: "Edited By", value: "username" },
        { text: "Changes", value: "content" },
      ],
      formatUTCtoPST,
    };
  },
  methods: {
    close() {
      this.$emit("input", false);
    },

    formatUsername(username) {
      return formatUsername(username, this.userMap);
    },
    ...mapActions({
      fetchUserList: "user/load",
    }),
  },
  props: {
    value: {},
  },
};
</script>

<style scoped>
.empty-value {
  color: #696767;
  font-style: italic;
}
</style>
